<template lang="pug">
.tableTop10-search
  .tableTop10-top
    .tableTop10-leftTop
      .tableTop10-inputArea
        input.tableTop10-input(id="search-input" placeholder="請輸入關鍵字搜尋" v-model="searchKeyword" :class="searchKeyword ? 'text-active': ''")
        .tableTop10-option(@click="unfolded = !unfolded" :class='unfolded? "tableTop10-option--folded": ""')
          i.tableTop10-iconFilter.icon-filter-16
        .tableTop10-searchKeywords(@click="search()")
          i.icon-lup.tableTop10-iconInputArea
      .tableTop10-iconFilter.show--smallScreens
        .title-iconFilter.icon-sort(@click='popupSort = true')
    .tableTop10-rightTop
      .tableTop10-social(v-if="userType!='government' && userType!='partners'")
        .tableTop10-socialItem
          a.icon-line(:href='"https://social-plugins.line.me/lineit/share?url=" + windowLocationHref'
            target="_blank")
        .tableTop10-socialItem
          a.icon-facebook(:href='"https://www.facebook.com/sharer/sharer.php?u=" + windowLocationHref'
            target="_blank")
      .tableTop10-addAuthority(v-if="userType === 'government'" @click="popupAddEditCommentGov = true") 新增
      .tableTop10-addAuthority(v-if="userType === 'partners'" @click="popupAddArticle = true") 新增話題
  Option(
    v-if="unfolded"
    ref='option'
    :preGovId='selectGovId'
    :prePartnerId='selectPartnerId'
    :preGovName='selectGovName'
    :preStart='start'
    :preEnd='end'
    :preSelectCategoryIds='selectCategoryIds'
    :preSelectType='selectType'
    :staticData='staticData.sidemenu.pages')
  .tableTop10-resetFilter(v-if='(start && end) || selectGovName || Object.getOwnPropertyNames(selectedCategories).length !== 0')
    .tableTop10-textResetWrapper
      span.tableTop10-textReset(v-if='start && end') {{ getDateString(start) }} - {{ getDateString(end) }}
      span.tableTop10-textReset(v-if='selectGovName') {{ selectGovName }}
      span.tableTop10-textReset(v-for='(category, idx) in selectedCategories' :key='idx') {{ category }}
    button.tableTop10-buttonReset(@click='clear') 清除
  PopupAddEditCommentGov(v-if="popupAddEditCommentGov" type='add' @closePopup="popupAddEditCommentGov = false" @isSuccess="isSuccess" @isError="isError" sectionText="新增澄清")
  PopupAddArticle(v-if="popupAddArticle" @closePopup="popupAddArticle = false" @onSuccess="isSuccess" @onError="isError" sectionText="新增話題")
  PopupContentIconText(v-if="popupContentIconText" @closePopup="popupContentIconText = false" :popupSimpleText="popupSimpleText" :iconType="iconType")
  PopupSort(v-if="popupSort" @sortByType="sortByType" @closePopup="popupSort = false" :sortType="sortType" :sortConfig="sortConfig")
</template>
<script>
import Option from '@/components/modules/search/option.vue';
import PopupAddEditCommentGov from '@/components/popup/popup_add_edit_comment_gov.vue';
import PopupAddArticle from '@/components/popup/popupAddArticle.vue';
import PopupContentIconText from '@/components/popup/popup_content_icon_text.vue';
import PopupSort from '@/components/modules/mobile/popup_sort.vue';
import $ from 'jquery';
import { getDateString } from '@/plugins/tool.js';
export default {
  components: {
    Option,
    PopupAddEditCommentGov,
    PopupAddArticle,
    PopupContentIconText,
    PopupSort
  },
  props: {
    staticData: Object,
    userType : String,
    sortConfig: Object
  },
  data() {
    return {
      searchKeyword: '',
      selectGovId: null,
      selectPartnerId: null,
      selectGovName: '',
      selectCategoryIds: '',
      selectTypeId: 0,
      selectType: '',
      unfolded: false,
      start: null,
      end: null,
      popupAddEditCommentGov: false,
      popupAddArticle: false,
      popupContentIconText: false,
      iconType: '',
      popupSimpleText: '',
      popupSort: false,
      sortType: '',
      hasCompletedTyping: true,
      windowLocationHref: ''
    };
  },
  computed: {
    selectedCategories() {
      var categoryList = {};
      if (this.selectCategoryIds) {
        var idList = this.selectCategoryIds.split('&categoryId=');
        if (this.$refs.option)
          idList.forEach(id => {
            categoryList[id] = this.$refs.option.categoryMap[id];
          });
      }
      return categoryList;
    }
  },
  mounted() {
    $('#search-input').on('compositionstart', () => {
      this.hasCompletedTyping = false;
    });
    $('#search-input').on('compositionend', () => {
      setTimeout(() => {
        this.hasCompletedTyping = true;
      }, 0);
    });
    $('#search-input').keypress(e => {
      if (e.key == 'Enter') if (this.hasCompletedTyping) this.search();
    });
  },
  created() {
    this.sortType = this.sortConfig.defaultSortType;
    this.windowLocationHref = encodeURIComponent(window.location.href);
  },
  methods: {
    search() {
      if (this.unfolded) {
        this.submit();
        this.unfolded = false;
      }
      const start = this.start ? new Date(this.start) : '';
      const end = this.end ? new Date(this.end) : '';
      this.$emit(
        'search',
        encodeURIComponent($.trim(this.searchKeyword)),
        start,
        end,
        this.selectGovId,
        this.selectPartnerId,
        this.selectCategoryIds,
        this.selectType,
      );
    },
    getDateString(date) {
      return getDateString(date);
    },
    submit() {
      const option = this.$refs.option;
      this.selectGovId = option.govId;
      this.selectPartnerId = option.partnerId;
      this.selectGovName = option.selectText;
      this.start = option.start;
      this.end = option.end;
      this.selectCategoryIds = '';
      this.selectType = ''  + option.typeMap[option.isTypeActive].en_name;
      for (var key in option.isActive) {
        if (option.isActive[key]) {
          if (this.selectCategoryIds === '') this.selectCategoryIds += key;
          else this.selectCategoryIds += '&categoryId=' + key;
        }
      }
    },
    submitAndSearch() {
      this.submit();
      this.search();
      this.unfolded = false;
    },
    sortByType(sortData) {
      if (sortData.type != null)
        this.sortType = sortData.type + sortData.direction.toString();
      else this.sortType = this.sortConfig.defaultSortType;
      this.$emit('sortByType', sortData);
    },
    clear() {
      if (this.$refs.option) {
        this.$refs.option.clear();
        this.submit();
      } else {
        this.selectGovId = null;
        this.selectPartnerId = null;
        this.selectGovName = '';
        this.start = '';
        this.end = '';
        this.selectCategoryIds = '';
      }
      this.$forceUpdate();
      this.search();
    },
    isSuccess() {
      this.popupContentIconText = true;
      this.iconType = 'complete';
      this.popupSimpleText = '新增完成';
    },
    isError() {
      this.popupContentIconText = true;
      this.iconType = 'error';
      this.popupSimpleText = '發生錯誤';
    }
  }
};
</script>
<style src="./search.vue.css"></style>
